<template>
  <div>
    <banner-card
      v-if="smAndDown"
      :fields="fields"
    />
    <div
      v-if="fields && file && file.url"
      class="banner content-center"
      :class="[
        { hero: hero },
        {'ma-6 mx-md-0': !hero },
        (siteConfig && siteConfig.navBottomBorderColor === 'green') ? 'border-yellow' : ''
      ]"
      :style="{
        backgroundImage: `url('${file.url}')`,
        height: smAndDown ? '150px' : ''
      }"
    >
      <banner-card
        v-if="!smAndDown"
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BannerCard from '@/components/snippets/banner-card'

export default {
  name: 'ImageBanner',
  components: {
    BannerCard
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    },
    hero: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    },
    file () {
      let file = null
      const asset = this.assets.find(
        a => a.sys.id === this.fields.bannerImage.sys.id
      )
      if (asset) {
        file = {
          title: asset.fields.title,
          url: asset.fields.file.url
        }
      }
      return file
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.banner {
  min-height: 300px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin: unset !important;

  &.hero {
    position: relative;
    min-height: 444px;
  }
}
</style>
